import {z} from 'zod';

import {t} from '../catalogueUi';

const LABEL_MAX_LENGTH = 255;
const NOTE_MAX_LENGTH = 2000;

/** Why a label is refused when it is empty or only blanks; also used for the same refusal from the server. */
export const labelRequiredMessage = () =>
  t('general.validations.fieldIsRequired', 'Field is required');

/** The label and note of a new pricelist version, within the limits the backend sets. */
export const pricelistVersionSchema = z.object({
  nextVersion: z
    .string()
    .trim()
    .max(LABEL_MAX_LENGTH)
    .refine(
      (label) => label.length > 0,
      () => ({message: labelRequiredMessage()})
    ),
  note: z.string().max(NOTE_MAX_LENGTH),
});
export type PricelistVersionValues = z.infer<typeof pricelistVersionSchema>;
